var map = {
	"./link-mail.tsx": [
		127,
		127
	],
	"./link-phone.tsx": [
		472,
		472
	],
	"./next-arrow.tsx": [
		320,
		320
	],
	"./popup-close.tsx": [
		282,
		282
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 911;
module.exports = webpackAsyncContext;